import styled from '@emotion/styled'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { object, func, bool } from 'prop-types'
import { t } from '@lingui/core/macro'

const MarginTopTypography = styled(Typography)`
  margin-top: 12px;
`

export const RangeExact = ({ form, setForm, disabled }) => {
  return (
    <>
      <MarginTopTypography variant="subtitle1">{t`Length`}</MarginTopTypography>
      <>
        <TextField
          name="minLength"
          disabled={disabled}
          value={form.min_length}
          onChange={({ target: { value } }) => {
            const newValue = parseInt(value, 10) < 0 ? 0 : value
            setForm(prev => ({
              ...prev,
              min_length: newValue,
            }))
          }}
          onBlur={() => {
            setForm({
              ...form,
              max_length:
                form.min_length && parseInt(form.min_length) > parseInt(form.max_length)
                  ? parseInt(form.min_length)
                  : form.max_length,
              min_length: form.min_length ? form.min_length : null,
            })
          }}
          variant="outlined"
          label={t`Minimum length`}
          type="number"
          margin="dense"
        />
        <TextField
          name="maxLength"
          disabled={disabled}
          value={form.max_length}
          onBlur={() => {
            setForm({
              ...form,
              max_length: form.max_length ? form.max_length : null,
              min_length:
                form.min_length && parseInt(form.min_length) >= parseInt(form.max_length)
                  ? parseInt(form.max_length, 10)
                  : form.min_length,
            })
          }}
          onChange={({ target: { value } }) => {
            const newValue = value ? parseInt(value) : null
            setForm({
              ...form,
              max_length: newValue,
            })
          }}
          variant="outlined"
          label={t`Maximum length`}
          type="number"
          margin="dense"
        />
      </>
    </>
  )
}

RangeExact.propTypes = {
  form: object.isRequired,
  setForm: func.isRequired,
  disabled: bool,
}
